import {Component, ElementRef, ViewChild} from '@angular/core';
import {ActionSheetController, AlertController, IonicPage, NavController, NavParams} from 'ionic-angular';
import {Retailer, StoreActivityDay, StoreDashboard} from "../../model/Store";
import {StoreService} from "../../services/StoreService";
import {apiconfig} from "../../app/api.config";
import {Order} from "../../model/Order";
import {OrderService} from "../../services/OrderService";
import {AuthService} from "../../services/AuthService";
import {OperationService} from "../../services/OperationService";
import {Operation} from "../../model/Operation";
import {OrderEditPage} from "../order-edit/order-edit";
import {OrderInfo} from "../nav/OrderInfo";
import {OrderViewPage} from "../order-view/order-view";
import {PcheckService} from "../../services/PcheckService";
import {ResourcePlanningService} from "../../services/ResourcePlanningService";
import {SlotsForStoreReportSlot} from "../../model/ReportingSlots";
import {LogaProxy} from "../../model/LogaProxy";

declare var google;

/**
 * Generated class for the StoreDashboardPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

export class MyFilter {
  storeId: number;
  year: number;
  month: number;
  operationId: number;
  dateLabel: Date;

  nextMonth() {
    if (this.month >= 11) {
      this.month = 0;
      this.year++;
    } else {
      this.month++;
    }
  }

  previousMonth() {
    if (this.month <= 0) {
      this.month = 11;
      this.year--;
    } else {
      this.month--;
    }
  }

}

@IonicPage()
@Component({
  selector: 'page-store-dashboard',
  templateUrl: 'store-dashboard.html',
})
export class StoreDashboardPage {

  public iconsURL: string = apiconfig.LOGA_ICONS;

  @ViewChild('map') mapElement: ElementRef;
  map: any;

  /**
   * global top page spinner
   */
  uiloading: boolean;

  /**
   * spinner for loading activites of a day
   */
  private uiOrderOfDayLoader: boolean;

  /**
   * spinner for the calendar and planning and section
   */
  private uiMonthCalendarLoader: boolean;


  /**
   * show we show all report lines, or only the ones visibles by default
   */
  uiShowAllActivityReport: boolean;

  /**
   * current filter
   */
  uiFilter: MyFilter = new MyFilter();

  private bubbleNumber: string[] = [];

  /**
   * store dash
   */
  storeDashboard: StoreDashboard;
  ordersOfDay: Order[];
  private currentActivityDay: StoreActivityDay;
  private operationsForPlanning: Operation[];

  /**
   * cache of retailers
   */
  private uiRetailers: Retailer[];
  /**
   * slots available for this store
   */
  private planningSlotsOfDay: SlotsForStoreReportSlot[];

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public storeService: StoreService,
              public orderService: OrderService,
              private pcheckService: PcheckService,
              public authService: AuthService,
              public operationService: OperationService,
              public resourcePlanningService: ResourcePlanningService,
              private actionSheetCtrl: ActionSheetController,
              private alertCtrl: AlertController) {
  }

  ionViewDidEnter() {

    this.uiShowAllActivityReport = false;
    for (let i = 0; i < 15; i++) {
      this.bubbleNumber[i] = '&#' + (9312 + i) + ';';
    }

    const storeId = this.navParams.data['storeId'];

    this.uiFilter.storeId = storeId;
    this.uiFilter.year = new Date().getFullYear();
    this.uiFilter.month = new Date().getMonth();
    this.uiFilter.operationId = null;


    this.storeService.loadRetailers().then(retailers => {
      this.uiRetailers = retailers;
      this.refreshPlanning();
    });


  }


  /**
   *
   * @param durationInMinutes
   */
  toFormatMissionDuration(durationInMinutes: number): string {
    let nbHours = Math.floor(durationInMinutes / 60);
    let nbMinutes = Math.floor(durationInMinutes % 60);

    if (nbMinutes && nbMinutes > 0) {
      return nbHours + "h" + nbMinutes;
    }

    return nbHours + "h";
  }

  onLoadOrder(id: number | string | ArrayBuffer | any, i: number) {

  }

  displayPlanning(ad: StoreActivityDay) {
    this.currentActivityDay = ad;
    this.uiOrderOfDayLoader = true;
    this.ordersOfDay = [];
    this.orderService.loadOrderFromApiWithWithEpoch(ad.logaDay, ad.logaDay, null, null).then(o => {
      this.uiOrderOfDayLoader = false;
      //keep only this store
      o.forEach(oo => {
        if (oo.location.id === this.storeDashboard.store.id) {
          this.ordersOfDay.push(oo);
        }
      })

    });

    console.log('starting to load slots');
    this.planningSlotsOfDay = [];
    this.resourcePlanningService.loadSlotsForStoreAndOperation(ad.logaDay, null, this.uiFilter.storeId).then(r => {
      console.log("slots loaded : :" + r.slots.length);
      this.planningSlotsOfDay = r.slots;
    });
  }

  adActiveClass(ad: StoreActivityDay) {
    if (this.currentActivityDay == null)
      return "inactive";
    else return ad.logaDay == this.currentActivityDay.logaDay ? "active" : "inactive";
  }

  newOrder(start: boolean) {

    /**
     let mdl = this.modalController.create(SelectOperationPage, null, {showBackdrop: true, enableBackdropDismiss: true});
     mdl.onDidDismiss(data => {
      console.log('onDidDismis');
    });
     mdl.present();
     **/
    this.operationsForPlanning = null;

    if (start)
      this.operationService.loadOperationsWithQuota(true, true).then(op => {
        this.operationsForPlanning = op;
      });

  }

  onSelectOperationToAdd(operation: Operation) {
    this.operationsForPlanning = null;

    let orderInfo = new OrderInfo();
    orderInfo.store = this.storeDashboard.store;
    orderInfo.operation = LogaProxy.of(operation.id, operation.code, operation.name, false);
    orderInfo.defaultDate = this.currentActivityDay.logaDay;

    return this.navCtrl.push(OrderEditPage, {orderInfo});
  }

  toggleReportVisibility() {
    this.uiShowAllActivityReport = !this.uiShowAllActivityReport;
  }

  //

  showMissionActionSheet(mission: Order) {
    this.actionSheetCtrl.create({
      title: 'Actions ' + mission.missionCode,
      buttons: [{
        text: "Afficher", icon: 'eye', handler: () => {
          this.processShowOrder(mission);
        }
      }, {
        text: "Dupliquer", icon: 'copy', handler: () => {
          if (this.authService.loggedUser.customerPlanningAllowed)
            this.processDuplicate(mission);
          else {
            this.alertCtrl.create({
              title: "Duplication impossible",
              message: "Vous n'êtes pas autorisé(e) à modifier le planning d'intervention."
            }).present();
          }

        }
      }]
    }).present();
  }


  // -- PLANNING NAVIGATION METHODS ---

  /**
   *
   */
  previousMonth() {
    this.uiFilter.previousMonth();
    this.refreshPlanning();
  }

  /**
   *
   */
  nextMonth() {
    this.uiFilter.nextMonth();
    this.refreshPlanning();
  }

  /**
   *
   */
  private refreshPlanning() {

    this.uiMonthCalendarLoader = true;
    this.currentActivityDay = null;
    this.ordersOfDay = null;

    //note: the backend expects human based month, for instance November is 11 not 10, so we add one on the month field
    this.storeService.loadStoreDashboard(this.uiFilter.storeId, this.uiFilter.year, 1 + this.uiFilter.month, this.uiFilter.operationId).then(d => {

      this.uiFilter.dateLabel = new Date();
      this.uiFilter.dateLabel.setFullYear(this.uiFilter.year);
      this.uiFilter.dateLabel.setMonth(this.uiFilter.month, 1);

      for (let i = 0; i < this.uiRetailers.length; i++) {
        if (this.uiRetailers[i].id === d.store.retailer) {
          d.store.uiRetailer = this.uiRetailers[i];
          break;
        }
      }

      this.storeDashboard = d;

      const days: number[] = [];
      if (d.activityWeeks != null)
        d.activityWeeks.forEach(w => {
          if (w.days != null)
            w.days.forEach(dd => {
              days.push(dd.logaDay);
            })
        })


      if (days != null && days.length > 0) {
        this.uiOrderOfDayLoader = true;

        this.orderService.loadOrderFromApiWithWithEpoch(Math.min(...days), Math.max(...days), null, this.uiFilter.storeId).then(o => {
          this.uiOrderOfDayLoader = false;
          this.ordersOfDay = [];
          //keep only this store
          o.forEach(oo => {
            if (oo.location.id === this.storeDashboard.store.id) {
              this.ordersOfDay.push(oo);
            }
          })
        });
      }
      this.uiMonthCalendarLoader = false;
    }).then(a => {
      const store = this.storeDashboard.store;
      if (store.address.lat != 0) {

        let latLng = new google.maps.LatLng(this.storeDashboard.store.address.lat, this.storeDashboard.store.address.lon);
        let mapOptions = {
          center: latLng,
          zoom: 16,
          disableDefaultUI: true,
          mapTypeId: google.maps.MapTypeId.ROADMAP
        }
        this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);

        let marker = new google.maps.Marker({
          map: this.map,
          animation: google.maps.Animation.DROP,
          position: latLng
        });
        let content = "<h4>" + store.name + "</h4>";
        this.addInfoWindow(marker, content);
      }
    })
  }

  addInfoWindow(marker, content) {
    let infoWindow = new google.maps.InfoWindow({
      content: content
    });
    google.maps.event.addListener(marker, 'click', () => {
      infoWindow.open(this.map, marker);
    });
  }


  private processShowOrder(mission: Order) {

    let orderInfo: OrderInfo = new OrderInfo();

    if (mission != undefined) {
      orderInfo.order = mission.id;

      // operation info
      orderInfo.operation.id = mission.operation.id;
      orderInfo.operation.name = mission.operation.name;

      // store info
      orderInfo.store.id = mission.location.id;
      orderInfo.store.name = mission.location.name;


      // load pcheck for this day
      this.pcheckService.findPcheck(mission.id)
        .then((pchecks) => {
          if (mission.customerEditPermissionAllowed)
            this.navCtrl.push(OrderEditPage, {orderInfo, pchecks});
          else
            this.navCtrl.push(OrderViewPage, {orderInfo, pchecks});
        }).catch(err => {
        let alert = this.alertCtrl.create({
          title: 'Erreur de Chargement',
          subTitle: "Impossible de retrouver les informations de présence pour l\' intervention. (id= " + mission.id + ")." +
            "<br/>Merci ré-essayer ultérieurement, avec de meilleurs conditions de réseau. <br/> Vous pouvez également remonter cet incident à votre interlocuteur IMPACT.",
          buttons: ['Fermer'],
        });
        return alert.present();
      });
    }
  }

  private processDuplicate(mission: Order) {
    let orderInfo = new OrderInfo();
    orderInfo.operation = LogaProxy.of(mission.operation.id, mission.operation.code, mission.operation.name, false);
    orderInfo.store = this.storeDashboard.store;
    orderInfo.duplicateFromOrder = mission.id;

    this.navCtrl.push(OrderEditPage, {orderInfo});
  }


  selectSlot(slot: SlotsForStoreReportSlot) {
    this.operationsForPlanning = null;

    let orderInfo = new OrderInfo();
    orderInfo.store = this.storeDashboard.store;
    orderInfo.operation = slot.operation;
    orderInfo.planningSlot = slot;

    return this.navCtrl.push(OrderEditPage, {orderInfo});
  }

}



// WEBPACK FOOTER //
// ./src/pages/store-dashboard/store-dashboard.ts